import { render } from "./PayPage.vue?vue&type=template&id=57e5ce5c&scoped=true"
import script from "./PayPage.vue?vue&type=script&lang=js"
export * from "./PayPage.vue?vue&type=script&lang=js"

import "./PayPage.vue?vue&type=style&index=0&id=57e5ce5c&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e5ce5c"]])

export default __exports__